import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "max-w-md" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-xl shadow-lg border p-6 bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700"
}
const _hoisted_6 = {
  key: 1,
  class: "rounded-xl shadow-lg border p-6 bg-white dark:bg-gray-800 border-red-100 dark:border-red-800"
}
const _hoisted_7 = { class: "flex items-center justify-center py-12 text-red-600 dark:text-red-400" }
const _hoisted_8 = {
  key: 2,
  class: "rounded-xl shadow-lg border bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700/90 overflow-hidden"
}
const _hoisted_9 = { class: "overflow-x-auto" }
const _hoisted_10 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700/40" }
const _hoisted_11 = { class: "bg-gray-50 dark:bg-gray-800/80 rounded-t-xl" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex items-center space-x-1" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "bg-white dark:bg-gray-800/90 divide-y divide-gray-200 dark:divide-gray-700/30" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-600 dark:text-gray-200" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-600 dark:text-gray-200" }
const _hoisted_19 = { class: "px-6 py-4 text-sm" }
const _hoisted_20 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_21 = {
  key: 0,
  class: "inline-block px-2 py-0.5 rounded mr-1 text-xs bg-blue-50 dark:bg-blue-900 text-blue-700 dark:text-blue-200"
}
const _hoisted_22 = {
  key: 1,
  class: "inline-block px-2 py-0.5 rounded mr-1 text-xs bg-green-50 dark:bg-green-900 text-green-700 dark:text-green-200"
}
const _hoisted_23 = {
  key: 2,
  class: "inline-block px-2 py-0.5 rounded mr-1 text-xs bg-yellow-50 dark:bg-yellow-900 text-yellow-700 dark:text-yellow-200"
}
const _hoisted_24 = {
  key: 3,
  class: "inline-block px-2 py-0.5 rounded mr-1 text-xs bg-purple-50 dark:bg-purple-900 text-purple-700 dark:text-purple-200"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300" }
const _hoisted_27 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300" }
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_30 = { class: "flex items-center space-x-3" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "bg-gray-50 dark:bg-gray-700/90"
}
const _hoisted_34 = {
  colspan: "7",
  class: "px-6 py-4"
}
const _hoisted_35 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_36 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_37 = { class: "p-2 rounded border text-xs overflow-auto max-h-40 bg-white dark:bg-gray-800 border-blue-200 dark:border-blue-800" }
const _hoisted_38 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_39 = { class: "p-2 rounded border text-xs overflow-auto max-h-40 bg-white dark:bg-gray-800 border-green-200 dark:border-green-800" }
const _hoisted_40 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_41 = { class: "p-2 rounded border text-xs overflow-auto max-h-40 bg-white dark:bg-gray-800 border-yellow-200 dark:border-yellow-800" }
const _hoisted_42 = {
  key: 3,
  class: "space-y-2"
}
const _hoisted_43 = { class: "p-2 rounded border text-xs overflow-auto max-h-40 bg-white dark:bg-gray-800 border-purple-200 dark:border-purple-800" }
const _hoisted_44 = {
  key: 1,
  class: "col-span-4 italic text-gray-500 dark:text-gray-400"
}
const _hoisted_45 = { class: "flex-1 flex justify-between sm:hidden" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" }
const _hoisted_49 = { class: "font-medium" }
const _hoisted_50 = { class: "font-medium" }
const _hoisted_51 = { class: "font-medium" }
const _hoisted_52 = {
  class: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px",
  "aria-label": "Pagination"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 3,
  class: "fixed inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_59 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_60 = { class: "sm:flex sm:items-start" }
const _hoisted_61 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_62 = { class: "mt-2" }

import { ref, onMounted, computed, watch, reactive, inject } from 'vue'
import { istioMeshApiClient } from '../../services/api/istioMeshApiClient'
import type { RequestFilter } from '../../types/request-filter'
import CreateFilterModal from '../../components/features/request-filter/CreateFilterModal.vue'
import Toast from '../../components/base/common/Toast.vue'
import { useTheme } from '../../utils/useTheme'

// Use theme via inject with a fallback

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const theme = inject('theme', useTheme())

// Data
const requestFilters = ref<RequestFilter[]>([])
const isLoading = ref(true)
const error = ref<string | null>(null)
const expandedRows = ref<Set<string>>(new Set())

// Create Modal State
const showCreateModal = ref(false)

const openCreateModal = () => {
  showCreateModal.value = true
}

const handleCreated = () => {
  fetchFilters()
}

// Sorting
const sortField = ref('createdAt')
const sortOrder = ref<'asc' | 'desc'>('desc')

// Search
const searchQuery = ref('')

// Pagination
const currentPage = ref(1)
const itemsPerPage = ref(10)

// Toast state
const toast = reactive({
  show: false,
  message: '',
  type: 'success' as 'success' | 'error',
  details: [] as string[]
})

const showToast = (message: string, type: 'success' | 'error', details?: string[]) => {
  toast.message = message
  toast.type = type
  toast.details = details || []
  toast.show = true
}

// Delete confirmation
const showDeleteConfirm = ref(false)
const filterToDelete = ref<string | null>(null)

const handleDeleteClick = (id: string, event: Event) => {
  event.stopPropagation() // Prevent row expansion
  filterToDelete.value = id
  showDeleteConfirm.value = true
}

const handleDelete = async () => {
  if (!filterToDelete.value) return

  try {
    await istioMeshApiClient.delete(`/platform/istio/request-filter/${filterToDelete.value}`)
    showToast('Filter deleted successfully', 'success')
    fetchFilters() // Refresh the list
  } catch (error: any) {
    let errorMessage = 'Failed to delete filter'
    if (error instanceof Error) {
      errorMessage = error.message
    }
    showToast('Failed to delete filter', 'error', [errorMessage])
  } finally {
    showDeleteConfirm.value = false
    filterToDelete.value = null
  }
}

// Edit mode
const filterToEdit = ref<RequestFilter | null>(null)

const handleEditClick = (filter: RequestFilter, event: Event) => {
  event.stopPropagation() // Prevent row expansion
  filterToEdit.value = filter
  showCreateModal.value = true // Use the same modal for editing
}

const handleEditSuccess = () => {
  showToast('Filter updated successfully', 'success')
  fetchFilters() // Refresh the list
  filterToEdit.value = null
}

// Computed
const filteredData = computed(() => {
  let result = [...requestFilters.value]

  // Apply search
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter((item) => {
      // Search in path and version
      if (item.path.toLowerCase().includes(query) || item.version.toLowerCase().includes(query)) {
        return true
      }

      // Deep search in filters
      if (item.filter) {
        // Search in body filters
        if (item.filter.body && JSON.stringify(item.filter.body).toLowerCase().includes(query)) {
          return true
        }
        // Search in query filters
        if (item.filter.query && JSON.stringify(item.filter.query).toLowerCase().includes(query)) {
          return true
        }
        // Search in params filters
        if (
          item.filter.params &&
          JSON.stringify(item.filter.params).toLowerCase().includes(query)
        ) {
          return true
        }
        // Search in headers filters
        if (
          item.filter.headers &&
          JSON.stringify(item.filter.headers).toLowerCase().includes(query)
        ) {
          return true
        }
      }

      return false
    })
  }

  // Apply sorting
  if (sortField.value) {
    result.sort((a, b) => {
      const aVal = a[sortField.value as keyof RequestFilter]
      const bVal = b[sortField.value as keyof RequestFilter]

      // Handle undefined values
      if (aVal === undefined && bVal === undefined) return 0
      if (aVal === undefined) return 1
      if (bVal === undefined) return -1

      // Handle dates
      if (sortField.value === 'createdAt' || sortField.value === 'updatedAt') {
        const aDate = new Date(aVal as string).getTime()
        const bDate = new Date(bVal as string).getTime()
        const comparison = aDate > bDate ? 1 : -1
        return sortOrder.value === 'asc' ? comparison : -comparison
      }

      // Handle other fields
      const comparison = String(aVal) > String(bVal) ? 1 : -1
      return sortOrder.value === 'asc' ? comparison : -comparison
    })
  }

  return result
})

const totalPages = computed(() => Math.ceil(filteredData.value.length / itemsPerPage.value))

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return filteredData.value.slice(start, end)
})

const displayedPages = computed(() => {
  const total = totalPages.value
  const current = currentPage.value
  const range: (number | string)[] = []

  if (total <= 7) {
    for (let i = 1; i <= total; i++) range.push(i)
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) range.push(i)
      range.push('...', total)
    } else if (current >= total - 2) {
      range.push(1, '...')
      for (let i = total - 4; i <= total; i++) range.push(i)
    } else {
      range.push(1, '...')
      for (let i = current - 1; i <= current + 1; i++) range.push(i)
      range.push('...', total)
    }
  }

  return range
})

// Table configuration
const columns = [
  {
    field: 'path',
    label: 'Path',
    sortable: true,
    searchable: true
  },
  {
    field: 'version',
    label: 'Version',
    sortable: true,
    searchable: true
  },
  {
    field: 'filter',
    label: 'Filters',
    sortable: false
  },
  {
    field: 'createdAt',
    label: 'Created',
    sortable: true
  },
  {
    field: 'updatedAt',
    label: 'Last Updated',
    sortable: true
  },
  {
    field: 'isWildcardPath',
    label: 'Wildcard Path',
    sortable: true
  },
  {
    field: 'actions',
    label: 'Actions',
    sortable: false
  }
]

// Helper Functions
const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return ''
  return new Date(dateString).toLocaleString()
}

const toggleExpand = (id: string) => {
  if (expandedRows.value.has(id)) {
    expandedRows.value.delete(id)
  } else {
    expandedRows.value.add(id)
  }
}

// Methods
const handleSort = (field: string) => {
  if (sortField.value === field) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field
    sortOrder.value = 'asc'
  }
}

// Watch for search changes to reset pagination
watch(searchQuery, () => {
  currentPage.value = 1
  expandedRows.value.clear()
})

// API Methods
const fetchFilters = async () => {
  try {
    isLoading.value = true
    const response = await istioMeshApiClient.get<RequestFilter[]>('/platform/istio/request-filter')
    requestFilters.value = response
  } catch (err) {
    error.value = 'Failed to load request filters'
  } finally {
    isLoading.value = false
  }
}

// Lifecycle
onMounted(() => {
  fetchFilters()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex justify-between items-center mb-6" }, [
      _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-600 dark:text-gray-100" }, "Request Filter", -1)),
      _createElementVNode("button", {
        class: "px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 flex items-center space-x-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400",
        onClick: openCreateModal
      }, _cache[10] || (_cache[10] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
            "clip-rule": "evenodd"
          })
        ], -1),
        _createElementVNode("span", null, "Create Filter", -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            class: "w-full pl-10 pr-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400",
            placeholder: "Search by path, version, or filter values..."
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
            _createElementVNode("svg", {
              class: "h-5 w-5 text-gray-400 dark:text-gray-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              })
            ])
          ], -1))
        ])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "flex items-center justify-center py-12" }, [
            _createElementVNode("div", { class: "w-8 h-8 border-4 border-blue-600 rounded-full border-t-transparent animate-spin" }),
            _createElementVNode("span", { class: "ml-3 text-gray-600 dark:text-gray-300" }, "Loading filters...")
          ], -1)
        ])))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(error.value), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", _hoisted_11, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                      return _createElementVNode("th", {
                        key: column.field,
                        class: _normalizeClass(["px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300 first:rounded-tl-xl last:rounded-tr-xl", { 'cursor-pointer': column.sortable }]),
                        onClick: ($event: any) => (column.sortable && handleSort(column.field))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", null, _toDisplayString(column.label), 1),
                          (column.sortable)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                (_openBlock(), _createElementBlock("svg", {
                                  class: _normalizeClass(["w-3 h-3 transform", 
                        sortField.value === column.field && sortOrder.value === 'asc'
                          ? 'text-blue-600 dark:text-blue-400'
                          : 'text-gray-400 dark:text-gray-500'
                      ]),
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, _cache[14] || (_cache[14] = [
                                  _createElementVNode("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M5 15l7-7 7 7"
                                  }, null, -1)
                                ]), 2)),
                                (_openBlock(), _createElementBlock("svg", {
                                  class: _normalizeClass(["w-3 h-3 transform", 
                        sortField.value === column.field && sortOrder.value === 'desc'
                          ? 'text-blue-600 dark:text-blue-400'
                          : 'text-gray-400 dark:text-gray-500'
                      ]),
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, _cache[15] || (_cache[15] = [
                                  _createElementVNode("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M19 9l-7 7-7-7"
                                  }, null, -1)
                                ]), 2))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_12)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item._id
                    }, [
                      _createElementVNode("tr", {
                        class: "cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/70 transition-colors duration-200",
                        onClick: ($event: any) => (toggleExpand(item._id))
                      }, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(item.path), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(item.version), 1),
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (item.filter)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (Object.keys(item.filter.body || {}).length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Body"))
                                    : _createCommentVNode("", true),
                                  (Object.keys(item.filter.query || {}).length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Query"))
                                    : _createCommentVNode("", true),
                                  (Object.keys(item.filter.params || {}).length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Params"))
                                    : _createCommentVNode("", true),
                                  (Object.keys(item.filter.headers || {}).length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Headers"))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(formatDate(item.createdAt)), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(formatDate(item.updatedAt)), 1),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                      item.isWildcardPath
                        ? 'bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-200'
                        : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300',
                      'px-2 py-1 rounded-full text-xs font-medium'
                    ])
                          }, _toDisplayString(item.isWildcardPath ? 'Yes' : 'No'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("button", {
                              class: "text-blue-500 dark:text-blue-400 hover:text-blue-600 dark:hover:text-blue-300 transition-colors",
                              title: "Edit filter",
                              onClick: ($event: any) => (handleEditClick(item, $event))
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-5 w-5",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
                              ], -1)
                            ]), 8, _hoisted_31),
                            _createElementVNode("button", {
                              class: "text-rose-500 dark:text-red-400 hover:text-rose-600 dark:hover:text-red-300 transition-colors",
                              title: "Delete filter",
                              onClick: ($event: any) => (handleDeleteClick(item._id, $event))
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-5 w-5",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                                  "clip-rule": "evenodd"
                                })
                              ], -1)
                            ]), 8, _hoisted_32)
                          ])
                        ])
                      ], 8, _hoisted_16),
                      (expandedRows.value.has(item._id))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                (item.filter)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (Object.keys(item.filter.body || {}).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "font-medium text-blue-700 dark:text-blue-300" }, "Body Filters", -1)),
                                            _createElementVNode("pre", _hoisted_37, _toDisplayString(JSON.stringify(item.filter.body, null, 2)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item.filter.query || {}).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "font-medium text-green-700 dark:text-green-300" }, " Query Filters ", -1)),
                                            _createElementVNode("pre", _hoisted_39, _toDisplayString(JSON.stringify(item.filter.query, null, 2)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item.filter.params || {}).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                            _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "font-medium text-yellow-700 dark:text-yellow-300" }, " Params Filters ", -1)),
                                            _createElementVNode("pre", _hoisted_41, _toDisplayString(JSON.stringify(item.filter.params, null, 2)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (Object.keys(item.filter.headers || {}).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                            _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "font-medium text-purple-700 dark:text-purple-300" }, " Headers Filters ", -1)),
                                            _createElementVNode("pre", _hoisted_43, _toDisplayString(JSON.stringify(item.filter.headers, null, 2)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_44, " No filters configured "))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            (totalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
          _unref(theme).isDark.value ? 'border-gray-700' : 'border-gray-200',
          'px-4 py-3 border-t sm:px-6 flex items-center justify-between'
        ])
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      disabled: currentPage.value === 1,
                      class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600'
                : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50',
              'relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md'
            ]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value--))
                    }, " Previous ", 10, _hoisted_46),
                    _createElementVNode("button", {
                      disabled: currentPage.value === totalPages.value,
                      class: _normalizeClass([
              _unref(theme).isDark.value
                ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600'
                : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50',
              'relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md'
            ]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value++))
                    }, " Next ", 10, _hoisted_47)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-600', 'text-sm'])
                      }, [
                        _cache[22] || (_cache[22] = _createTextVNode(" Showing ")),
                        _createElementVNode("span", _hoisted_49, _toDisplayString((currentPage.value - 1) * itemsPerPage.value + 1), 1),
                        _cache[23] || (_cache[23] = _createTextVNode(" to ")),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(Math.min(currentPage.value * itemsPerPage.value, filteredData.value.length)), 1),
                        _cache[24] || (_cache[24] = _createTextVNode(" of ")),
                        _createElementVNode("span", _hoisted_51, _toDisplayString(filteredData.value.length), 1),
                        _cache[25] || (_cache[25] = _createTextVNode(" results "))
                      ], 2)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("nav", _hoisted_52, [
                        _createElementVNode("button", {
                          disabled: currentPage.value === 1,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 rounded-l-md border text-sm font-medium'
                ]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (currentPage.value = 1))
                        }, _cache[26] || (_cache[26] = [
                          _createElementVNode("span", { class: "sr-only" }, "First", -1),
                          _createTextVNode(" ⟪ ")
                        ]), 10, _hoisted_53),
                        _createElementVNode("button", {
                          disabled: currentPage.value === 1,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 border text-sm font-medium'
                ]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (currentPage.value--))
                        }, _cache[27] || (_cache[27] = [
                          _createElementVNode("span", { class: "sr-only" }, "Previous", -1),
                          _createTextVNode(" ⟨ ")
                        ]), 10, _hoisted_54),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPages.value, (page) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
                            (page !== '...')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass([
                    currentPage.value === page
                      ? _unref(theme).isDark.value
                        ? 'z-10 bg-blue-900 border-blue-600 text-blue-300'
                        : 'z-10 bg-blue-50 border-blue-400 text-blue-500'
                      : _unref(theme).isDark.value
                        ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                    'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                  ]),
                                  onClick: ($event: any) => (currentPage.value = Number(page))
                                }, _toDisplayString(page), 11, _hoisted_55))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([
                    _unref(theme).isDark.value
                      ? 'border-gray-600 bg-gray-700 text-gray-400'
                      : 'border-gray-300 bg-white text-gray-700',
                    'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                  ])
                                }, " ... ", 2))
                          ], 64))
                        }), 128)),
                        _createElementVNode("button", {
                          disabled: currentPage.value === totalPages.value,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 border text-sm font-medium'
                ]),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value++))
                        }, _cache[28] || (_cache[28] = [
                          _createElementVNode("span", { class: "sr-only" }, "Next", -1),
                          _createTextVNode(" ⟩ ")
                        ]), 10, _hoisted_56),
                        _createElementVNode("button", {
                          disabled: currentPage.value === totalPages.value,
                          class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-gray-300 hover:bg-gray-600'
                    : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                  'relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium'
                ]),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (currentPage.value = totalPages.value))
                        }, _cache[29] || (_cache[29] = [
                          _createElementVNode("span", { class: "sr-only" }, "Last", -1),
                          _createTextVNode(" ⟫ ")
                        ]), 10, _hoisted_57)
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])),
    _createVNode(Toast, {
      show: toast.show,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((toast.show) = $event)),
      message: toast.message,
      type: toast.type,
      details: toast.details,
      duration: 5000
    }, null, 8, ["show", "message", "type", "details"]),
    (showDeleteConfirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _cache[31] || (_cache[31] = _createElementVNode("div", {
              class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800 text-white' : 'bg-white text-gray-900',
            'inline-block align-bottom rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'
          ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
              'px-4 pt-5 pb-4 sm:p-6 sm:pb-4'
            ])
              }, [
                _createElementVNode("div", _hoisted_60, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-rose-100 dark:bg-red-900 sm:mx-0 sm:h-10 sm:w-10" }, [
                    _createElementVNode("svg", {
                      class: "h-6 w-6 text-rose-500 dark:text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("h3", {
                      class: _normalizeClass([
                    _unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900',
                    'text-lg leading-6 font-medium'
                  ])
                    }, " Delete Filter ", 2),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("p", {
                        class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-500', 'text-sm'])
                      }, " Are you sure you want to delete this filter? This action cannot be undone. ", 2)
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-700' : 'bg-gray-50',
              'px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-3'
            ])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-2.5 bg-rose-500 dark:bg-red-600 text-base font-medium text-white hover:bg-rose-600 dark:hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-red-500 transition-colors duration-200 sm:w-auto sm:text-sm",
                  onClick: handleDelete
                }, " Delete "),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass([
                _unref(theme).isDark.value
                  ? 'border-gray-600 bg-gray-700 text-gray-200 hover:bg-gray-600'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50',
                'mt-3 w-full inline-flex justify-center rounded-md border shadow-sm px-6 py-2.5 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 sm:mt-0 sm:w-auto sm:text-sm'
              ]),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (showDeleteConfirm.value = false))
                }, " Cancel ", 2)
              ], 2)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CreateFilterModal, {
      modelValue: showCreateModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showCreateModal).value = $event)),
      "edit-mode": !!filterToEdit.value,
      "filter-data": filterToEdit.value,
      onCreated: handleCreated,
      onUpdated: handleEditSuccess
    }, null, 8, ["modelValue", "edit-mode", "filter-data"])
  ]))
}
}

})